import type {OrderListItem} from '../../types';

import {GiftOutlined} from '@ant-design/icons';
import {Badge, Chip} from '@ds/components';
import {useLocation, useNavigate} from 'react-router-dom';
import {numberFormat} from 'utils/Helper';

type OrderCardProps = {
  order: OrderListItem;
};

const OrderCard: React.FC<OrderCardProps> = ({order}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const statusColor =
    order.order_status_key === 'edited'
      ? 'warning'
      : order.order_status_key === 'accept'
        ? 'success'
        : order.order_status_key === 'declined'
          ? 'error'
          : 'default';
  const orderDate = new Date(order.order_date);
  const formattedDate = `${orderDate.toLocaleDateString('fa-IR', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  })} - ${orderDate.toLocaleTimeString('fa-IR', {hour: '2-digit', minute: '2-digit'})}`;
  const handleClick = () => {
    const query = new URLSearchParams({
      from: location.pathname
    });

    navigate({
      pathname: `/orders/${order.id}/status`,
      search: query.toString()
    });
  };

  return (
    <button
      type="button"
      className="mx-3.75 my-2.5 flex w-[calc(100%-30px)] flex-col gap-1 rounded-xl border border-gray-03 text-start"
      onClick={handleClick}
    >
      <span className="flex justify-between border-b border-gray-03 p-3 text-body-sm text-gray-07">
        <span>{formattedDate}</span>
        <span>کد سفارش: {order.code}</span>
      </span>
      <span className="flex flex-col gap-1 p-3">
        <span className="flex items-center justify-between gap-1">
          <strong className="text-subtitle-md text-gray-09">{order.full_name}</strong>
          {order.order_status_key && order.order_status && (
            <Chip
              interactive={false}
              label={order.order_status}
              variant="filled"
              color={statusColor}
            />
          )}
        </span>
        <span className="flex gap-1 text-body-sm text-gray-07">
          <span>{order.product_count} کالا</span>
          <span>|</span>
          <span>{order.order_status}</span>
        </span>
        <span className="flex flex-wrap gap-2.5">
          {order.has_coupon && (
            <Badge variant="status" color="primary" size="md" className="gap-1">
              <GiftOutlined aria-hidden />
              دارای کوپن
            </Badge>
          )}
          {order.order_modified && (
            <Badge variant="status" color="warning" size="md">
              اصلاح شده
            </Badge>
          )}
        </span>
      </span>
      <span className="p-3 text-subtitle-md text-gray-09">
        <span className="text-body-sm-emphasis">مبلغ پرداختی: </span>
        {numberFormat(order.price ?? 0)}
        <span className="text-body-sm-emphasis"> تومان</span>
      </span>
    </button>
  );
};

export default OrderCard;
